import { useEffect, useRef } from "react";

const InstagramEmbed = ({ url }) => {
  const embedRef = useRef(null);

  useEffect(() => {
    if (!url || !embedRef.current) return;

    // Injecter le blockquote
    embedRef.current.innerHTML = `
      <blockquote 
        class="instagram-media" 
        data-instgrm-permalink="${url}" 
        data-instgrm-version="14"
        style="background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5), 0 1px 10px 0 rgba(0,0,0,0.15); margin:0 auto; max-width:540px; min-width:326px; padding:0; width:100%;">
      </blockquote>
    `;

    // Charger ou relancer le script Instagram après l'injection
    const processEmbeds = () => {
      if (window.instgrm && window.instgrm.Embeds) {
        window.instgrm.Embeds.process();
      }
    };

    if (!window.instgrm) {
      const script = document.createElement("script");
      script.src = "https://www.instagram.com/embed.js";
      script.async = true;
      script.onload = processEmbeds;
      document.body.appendChild(script);
    } else {
      processEmbeds();
    }

  }, [url]);

  return (
    <div className="flex justify-center my-10">
      <div
        ref={embedRef}
        style={{
          transform: "scale(0.85)",
          transformOrigin: "top center",
          maxHeight: "800px",
          overflow: "scroll",
          width: "100%",
          margin: "0 auto"
        }}
      />
    </div>
  );
};

export default InstagramEmbed;